import GestorDocumentalService from 'src/modules/gestorDocumental/gestorDocumentalService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'GESTORDOCUMENTAL_VIEW';

const gestorDocumentalViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: gestorDocumentalViewActions.FIND_STARTED,
      });

      const record = await GestorDocumentalService.find(id);

      dispatch({
        type: gestorDocumentalViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: gestorDocumentalViewActions.FIND_ERROR,
      });

      getHistory().push('/gestor-documental');
    }
  },
};

export default gestorDocumentalViewActions;
